import {CrossIcon, DraftIcon, Grid, IconButton, Typography} from '@logistics-frontend/blocks'
import React from 'react'

import {classes} from './Preview.classes'

type Props = {
  fileName: string
  onDelete: VoidFunction
}

export const Preview: React.FC<Props> = ({fileName, onDelete}) => {
  return (
    <Grid
      alignItems="center"
      className={classes.container}
      direction="column"
      justify="center"
      size="s"
      wrap="nowrap"
      container
    >
      <Grid item>
        <DraftIcon className={classes.icon} />
      </Grid>
      <Grid className={classes.fileNameContainer} item>
        <Typography className={classes.fileName} color="invert" title={fileName} variant="caption1" whiteSpace="nowrap">
          {fileName}
        </Typography>
      </Grid>
      <IconButton className={classes.deleteButton} onPress={onDelete} shape="circle" size="xs">
        <CrossIcon color="inherit" />
      </IconButton>
    </Grid>
  )
}
